module.exports = __webpack_public_path__ + "static/media/step-one-big.d0c6a0e1.webp";